module.exports = __webpack_public_path__ + "img/mew-logo.7d20a13f.svg";